module.exports = __webpack_public_path__ + "img/square16mmx16mmStickerPackSize5_200px-min.png";